// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__KfseN","modalForm":"UpgradeEpcsModal_modalForm__1vrAb","modalFooter":"UpgradeEpcsModal_modalFooter__2y5-J"};